export default __webpack_public_path__ + "static/media/Group_52.3cc9c0aa.png";